import { render, staticRenderFns } from "./PersonSelect.vue?vue&type=template&id=71fd732b&"
import script from "./PersonSelect.vue?vue&type=script&lang=js&"
export * from "./PersonSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports